import React, { useEffect, useState } from 'react'
import Text from '../../atoms/text/Text'
import Card from '../../atoms/card/Card'
import VerticalGroup from '../../atoms/verticalgroup/VerticalGroup'
import InlineGroup from '../../atoms/inlinegroup/InlineGroup'
import ResultsTable from './table/ResultsTable'
import ArrowHeader from './components/ArrowHeader'
import { TeamsWithColours } from './RoundResults'

import Theme from '../../../styles/_theme.module.scss'

import './RoundResultsTablePage.scss'

interface Props {
  teams: TeamsWithColours[]
  executiveDecisions: ModelAPI.Reporting.ExcoDecision
}

const getDotColour = (idx: number) => {
  switch (idx) {
    case 0: return Theme.yellow
    case 1: return Theme.green
    case 2: return Theme.blue
    default: return 'blue'
  }
}

const RoundResultsExecutiveDecisionsTableTwo: React.FC<Props> = ({
  executiveDecisions,
  teams
}) => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    let timer = setTimeout(() => setShow(true), 2000)

    return () => clearTimeout(timer)
  }, [show])

  const maxNumberOfRows = Math.max(...executiveDecisions.options!.map(o => o.teams.length))

  return (
    <VerticalGroup full center wide>
      <Text size="6xl" bold colour='primaryDark'>Risk Forum</Text>
      <Text size="4xl" className="mb-4" bold colour='blue'>
        The right answer is sometimes unclear
      </Text>
      <InlineGroup fullHeight>
        <Card
          wide
          sharp
          padding={0}
          className='executive-decisions-card'>
          <InlineGroup spread fullHeight>
            <VerticalGroup
              wide
              className={show ? 'show-bids pt-6' : 'no-show-options'}
            >
              <ArrowHeader text={executiveDecisions.name} colour={Theme.primaryDark}></ArrowHeader>
              <VerticalGroup full className='mt-4'>
                {executiveDecisions.options?.map(
                  (option, i) => (
                    <InlineGroup key={i} className='pl-8 pr-4' fullHeight>
                      <VerticalGroup center>
                        <div className='options-dot mr-4' style={{backgroundColor: getDotColour(i)}}></div>
                        {i >= 2 ? <span className='dot-separator mr-4 mt-1' />  : <span className='dot-separator mr-4 mt-1 mb-1' />}

                      </VerticalGroup>
                      <VerticalGroup>
                        <InlineGroup block verticalCenter>
                          <Text size='xl' bold>{option.name}</Text>
                        </InlineGroup>
                        <Text size='lg' className='pb-4' isHtml>{option.outcome}</Text>
                      </VerticalGroup>
                    </InlineGroup>
                  )
                )}
              </VerticalGroup>
            </VerticalGroup>
            <VerticalGroup wide full className='p-8'>
              <ResultsTable fadeIn id={executiveDecisions.id}>
                <thead>
                  <tr>
                    {executiveDecisions.options?.map(
                      (option, i) => (
                        <th key={i} style={{color: getDotColour(i)}}>{option.name}</th>
                      )
                    )}
                  </tr>
                </thead>
                <tbody>
                  {new Array(maxNumberOfRows).fill(0).map((_, index) => {
                    return (
                      <tr key={index}>
                        {executiveDecisions.options?.map((option, i) => {
                          const teamForTable = teams.find(t => t.teamId === option.teams[index])
                          return (
                            <td
                              key={i}
                              style={{ color: `${teamForTable?.colour}` }}
                            >
                              {teamForTable?.teamName}
                            </td>
                          )
                        })}
                      </tr>
                    )
                  })}
                </tbody>
              </ResultsTable>
            </VerticalGroup>
          </InlineGroup>
        </Card>
      </InlineGroup>
    </VerticalGroup>
  )
}

export default RoundResultsExecutiveDecisionsTableTwo